// import React from "react";
// import { Navigate, useLocation } from "react-router-dom";

// export default function PrivateRoute({ children }) {
//   const location = useLocation();
//   const token = localStorage.getItem("token");

//   const isAuthenticated =
//     token && token !== "undefined" && token !== "null";

//   if (!isAuthenticated) {
//     return (
//       <Navigate
//         to="/login"
//         replace
//         state={{ from: location }} 
//       />
//     );
//   }

//   return children;
// }
import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";

export default function PrivateRoute({ children }) {
  const location = useLocation();

  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (token && token !== "undefined" && token !== "null") {
      setIsAuthenticated(true);
    }

    setLoading(false);
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location }}
      />
    );
  }

  return children;
}